/**
 * EEMENTOR × Intercom.
 * "Chat with an engineer" buttons ([data-ee-chat]) stay hidden until the Intercom Messenger
 * (added by the official Intercom Shopify app embed) is on the page, then open it pre-filled.
 * Inside the 3D generator the message carries the current pack configuration.
 */

const READY_TIMEOUT = 20000;

function whenIntercom() {
  return new Promise((resolve) => {
    const start = Date.now();
    (function check() {
      if (typeof window.Intercom === 'function') return resolve(true);
      if (Date.now() - start > READY_TIMEOUT) return resolve(false);
      setTimeout(check, 400);
    })();
  });
}

if (!window.__eeIntercomBound) {
  window.__eeIntercomBound = true;

  whenIntercom().then((ready) => {
    if (ready) document.documentElement.classList.add('ee-has-intercom');
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ee-chat]');
    if (!button || typeof window.Intercom !== 'function') return;
    event.preventDefault();

    let message = button.dataset.eeChat || '';
    const builder = button.closest('ee-pack-builder');
    if (builder?.currentSummary) {
      message = `Hi! I designed this pack in the 3D generator: ${builder.currentSummary}. Can you help me with it?`;
    }
    window.Intercom('showNewMessage', message);
  });
}
